// extracted by mini-css-extract-plugin
export default {"title":"putR9mfGiEatxqDPC3MZ"};